<template>
  <div class="videoPlay_phone">
    <div class="container">
      <!-- logo start -->
      <div class="logo">
        <img src="/statics/image/phone/logo.png" class="thumb" alt />
      </div>
      <!-- logo end -->
      <!-- menu start -->
      <div class="menu flex">
        <div class="item cur" @click="toPage(-1,-1)">首页</div>
        <div class="item" @click="toPage(11,indexa)">新区概况</div>
        <div class="item" @click="toPage(12,indexb)">新区要闻</div>
        <div class="item" @click="toPage(13,indexc)">招商引资</div>
      </div>
      <!-- menu end -->
      <!-- content start -->
      <div class="content">
        <div class="video_con">
          <video
            :src="adddom(videodetail.video_file)"
            :poster="videodetail.thumb_image"
            width="100%"
            height="100%"
            controls
            autoplay
          ></video>
          <div class="video_title">{{ videodetail.title }}</div>
          <div class="video_desc">{{ videodetail.count }}次播放量 发布时间{{ videodetail.publish_at }}</div>
        </div>
        <div class="recom_com">
          <div class="recom_title">推荐视频</div>
          <div class="recom_list" v-if="recomVideo.length">
            <div
              class="recom_item"
              v-for="item in recomVideo"
              :key="item.id"
              @click="toPlay(item.video_id)"
            >
              <span class="el-icon-video-camera-solid"></span>
              <div class="item_title">{{ item.title }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- content end -->
      <!-- footer start -->
      <div class="footer">
        <p>主办：河北衡水高新技术产业开发区</p>
        <p>网站标识：1311000037</p>
        <p>公安备案：13110802000107</p>
        <p>地址：衡水市永兴西路1988号</p>
        <a href="http://beian.miit.gov.cn/" class="map">冀ICP备16022288号-1 网站地图</a>
        <p>技术支持：河北中信联信息技术有限公司</p>
        <img src="/statics/image/phone/gov.png" class="gov" alt />
      </div>
      <!-- footer end -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      videoId: "",
      videodetail: {},
      recomVideo: [],
      catelist: [],
      indexa: "",
      indexb: "",
      indexc: ""
    };
  },
  created() {
    this.videoId = this.$route.query.id; // 421 this.$route.query.id
    function mobileskip() {
      var mobileAgent = new Array(
        "iphone",
        "ipod",
        "ipad",
        "android",
        "mobile",
        "blackberry",
        "webos",
        "incognito",
        "webmate",
        "bada",
        "nokia",
        "lg",
        "ucweb",
        "skyfire"
      );
      var browser = navigator.userAgent.toLowerCase();
      var isMobile = false; //记录是否移动端
      for (var i = 0; i < mobileAgent.length; i++) {
        if (browser.indexOf(mobileAgent[i]) != -1) {
          isMobile = true;
          break;
        }
      }
      return isMobile;
    }
    if (mobileskip()) {
      this.getVideoInfo();
      this.getNav();
      // 移动端
    } else {
      this.$router.push({
        path: "/videoPlay",
        query: {
          id: this.videoId
        }
      });
    }
  },
  watch: {
    $route(to, from) {
      this.videoId = this.$route.query.id;
      this.getVideoInfo();
    }
  },
  methods: {
    toPath(url, obj) {
      if (this.$route.fullPath == url) {
        return;
      }
      if (this.$route.path == url) {
        this.$router.push({
          path: url,
          query: obj
        });
        return;
      }
      this.$router.push({
        path: url,
        query: obj
      });
    },
    toPage(id, index) {
      if (id == "-1") {
        this.toPath("/", {});
      } else {
        this.toPath("/xqNews", { id: id, index: index });
      }
    },
    getNav() {
      var that = this;
      that.$api.index.catelist({}).then(function(res) {
        if (res.code == 200) {
          that.catelist = res.result.all_cate;
          for (var i in that.catelist) {
            if (that.catelist[i].id == "11") {
              that.indexa = i;
            } else if (that.catelist[i].id == "12") {
              that.indexb = i;
            } else if (that.catelist[i].id == "13") {
              that.indexc = i;
            }
          }
          //   console.log(that.indexa,that.indexb,that.indexc);
        }
      });
    },
    // 图片拼接地址
    adddom(src) {
      if (src == "" || src == undefined || src == null) {
        console.log("src地址有问题");
        return "";
      }
      if (src.substr(0, 4).toLowerCase() === "http") {
        return src;
      }
      return this.$url + src;
    },
    getVideoInfo() {
      var that = this;
      var ps = {
        video_id: that.videoId
      };
      that.$api.index.videodetail(ps).then(function(res) {
        if (res.code == 200) {
          that.videodetail = res.result.video;
          that.recomVideo = res.result.recom;
        }
      });
    },
    toPlay(id) {
      // console.log(id);
      this.$router.push({
        path: "/videoPlayPhone",
        query: {
          id: id
        }
      });
    }
  }
};
</script>

<style>
.video_title {
  font-size: 0.4rem;
  margin-top: 0.12rem;
}
.video_desc {
  margin-top: 0.04rem;
  color: #707070;
  font-size: 0.267rem;
}
.recom_com {
  margin-top: 0.134rem;
}
.recom_title {
  font-size: 0.4rem;
  color: #000;
  display: flex;
  align-items: center;
}
.recom_title::before {
  content: "";
  display: block;
  width: 0.053rem;
  height: 0.267rem;
  background: #0047a9;
  margin-right: 0.16rem;
}
.recom_list {
  margin-top: 0.16rem;
}
.recom_list .recom_item {
  margin-top: 0.106rem;
  border-bottom: 2px dotted #ccc;
  font-size: 0.36rem;
  color: #0f0f0f;
  display: flex;
  align-items: center;
}
.recom_item .item_title {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin-left: 0.2rem;
}
.recom_item .el-icon-video-camera-solid:before {
  font-size: 0.42rem;
}
</style>
